import routes from './error.routes';

import exceptionHandlerConfig from './configs/exceptionHandler.config';

import errorMessagesComponent from './components/error.messages.component';
import httpErrorComponent from './components/http.error.component';

const errorModule = angular.module('journey-ui.shared.error', [])
  .config(routes)
  .config(exceptionHandlerConfig)

  .component('errorMessages', errorMessagesComponent)
  .component('httpError', httpErrorComponent);

export default errorModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/error/index.js